import { ListOfficerActionResult } from '../models/list-officer-action-result.models';
import { Officer } from '../models/list-officer.models';

export const LIST_OFFICER_STORE_KEY = 'list-officer';

export interface IListOfficerState {
  officers: Officer[];
  paginationOfficers: Officer[];
  actionResult: ListOfficerActionResult | null;
  filteredOfficersTotalCount: number;
  query: string;
  isLoading: boolean;
}

export const initialState: IListOfficerState = {
  officers: [],
  paginationOfficers: [],
  actionResult: null,
  filteredOfficersTotalCount: 0,
  query: '',
  isLoading: false,
};
